import { BaseModel } from '@core/base.model';
import { modulesDefault, UserModules } from '@core/constants/modules.contants';

export class UserProfile extends BaseModel {
  name: string = '';
  email: string = '';
  telephone: string = '';

  firebaseUids: string[] = [];

  modules: UserModules = modulesDefault;

  static build(dto: UserProfile) {
    const entity = new UserProfile(dto.id, dto.createdAt, dto.updatedAt);
    entity.name = dto.name;
    entity.email = dto.email;
    entity.telephone = dto.telephone;
    entity.firebaseUids = dto.firebaseUids;
    entity.modules = { ...modulesDefault, ...dto.modules };
    return entity;
  }
}
